<template>
<div>
    <legend>{{ legend }}
      <a @click="$emit('close')" href="#" class="btn pull-right closeWindow">
        <i class="fas fa-times fa-2x"></i>
      </a>
    </legend>
    <form>
      <v-input :errors="errors" type="text" name="title" title="Titre *" v-model="current.eventTitle" v-validate="'required'" data-vv-name="Titre"></v-input>
      <calProviders :isEdited="isEdited" :current="current" :users="users" :renforts="renforts" :errors="errors" name="user_id"></calProviders>
      <div class="row">
        <v-date :errors="errors" name="start" title="Date de début *" format="YYYY-MM-DD HH:mm:ss" v-model="current.eventStart" v-validate="'required'" data-vv-name="Date de début"></v-date>
        <v-date :errors="errors" name="end" title="Date de fin *" format="YYYY-MM-DD HH:mm:ss" v-model="current.eventEnd" v-validate="'required'" data-vv-name="Date de fin"></v-date>
      </div>
      <div class="form-group">
        <div class="form__label">
          <label>Choisissez une couleur *: </label>
        </div>
        <div class="form__input">
          <swatches v-model="current.color" inline @input="validate"></swatches>
        </div>
      </div>
      <button v-show="isEdited" @click.prevent="delEvent" class="btn btn-block btn-right btn-danger">Supprimer</button>
      <button @click.prevent="addEvent()" class="btn btn-block green" >{{isEdited ? 'Sauvegarder': 'Créer'}}</button>
    </form>
    <div class="alert alert-danger"  v-show="customErrorMessage.error === true&&ferrors.all().length>0||customErrors.length>0">
        <h3>{{customErrorMessage.message}}</h3><hr>
        <ul>
          <li v-for="(error,eidx) in ferrors.all()" v-bind:key="eidx">{{ error }}</li>
          <li v-for="(cerror,cidx) in customErrors" v-bind:key="cidx">{{ cerror }}</li>
        </ul>
    </div>
</div>
</template>
<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import Swatches from 'vue-swatches';
import "vue-swatches/dist/vue-swatches.css";
export default {
  name: 'calEvent',
  components: {
    Swatches,
    VueCtkDateTimePicker
  },
  props: ['current', 'legend', 'users', 'renforts'],
  data () {
    return {
      errors: {},
      colors: [
        ['#F64272', '#F6648B', '#F493A7', '#F891A6', '#FFCCD5' ],
        ['#8b5aff', '#a27bff', '#b99cff'],
      ],
      customErrors: [],
      customErrorMessage:{
        error:false,
        message: '',
      },
      isEdited:this.current.hasOwnProperty('eventId')
    }
  },
  methods: {
    addEvent() {
      if(this.validate()){
  			const newEvent = {
          title: this.current.eventTitle,
          start: this.current.eventStart,
          end: this.current.eventEnd,
          color: this.current.color,
          user_id: this.current.userId,
          renfort_id: this.current.renfortId,
          event_id: this.current.eventId,
        }
        let met = 'post'
        let route = 'calendar/event'
        if(this.isEdited){
          met = 'put'
          route += '/' + this.current.eventId
        }
        axios[met](route, newEvent )
          .then(response => {
            this.$emit('snotify')
            this.$emit('refetch-events')
            this.$emit('close')
          })
      }
    },
    delEvent() {
      let confirmConfig={
        title:'Êtes-vous sûr de vouloir supprimer ?',
        btnOkLabel:'<i class="icon-ok-sign icon-white"></i> Oui',
        btnCancelLabel:'<i class="icon-remove-sign"></i> Non',
        btnOkClass:"btn green",
        btnCancelClass:"btn btn-danger",
        placement:'bottom',
        onConfirm:(event,element)=>{
          event.preventDefault()//prevent scroll top
          axios.delete('calendar/event/' + this.current.eventId)
            .then(response =>{
              this.$emit('snotify')
              this.$emit('refetch-events')
              this.$emit('close')
          })
        }
      };
      $(event.target).confirmation(confirmConfig);
      $(event.target).confirmation('show');
    },
    validate(){
      let regex = RegExp('^#([0-9a-f]{3}){1,2}$','i')
      let err = 0
      this.customErrors=[]

      if(this.current.userId=="" && this.current.renfortId==""){
        err++
        this.customErrors.push("Veuillez sélectionner un prestataire ou un renfort")
      }
      //event===null when dismiss from select
      if(!regex.test(this.current.color)){
        err++
        this.customErrors.push('Veuillez choisir une couleur pour cette événement')
      }
      this.$validator.validateAll().then((result) =>{
          if (!result) {
              err+=this.ferrors.all().length
          }
      });
      if(err>0){
        let msg = (err>1) ? 'Erreurs lors de la validation :' : 'Erreur lors de la validation :'
        this.customErrorMessage = {
            error : true,
            message : msg
        }
        return false
      }
      return true
    }
  }
};
</script>
<style>
.field-input{
  border-color: #c2cad8!important;
}
</style>

